import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M797.319865 985.881673L344.771525 1438.43001 533.333333 1626.99182 985.881673 1174.44348 1438.43001 1626.99182 1626.99182 1438.43001 1174.44348 985.881673 1626.99182 533.333333 1438.43001 344.771525 985.881673 797.319865 533.333333 344.771525 344.771525 533.333333z",
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: "1"
});

var IconXSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconXSolid, _Component);

  var _super = _createSuper(IconXSolid);

  function IconXSolid() {
    _classCallCheck(this, IconXSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconXSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconX",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconXSolid.displayName = "IconXSolid";
  return IconXSolid;
}(Component);

IconXSolid.glyphName = 'x';
IconXSolid.variant = 'Solid';
IconXSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconXSolid;
export { IconXSolid };